import { getObjectId, isTicketClosed } from 'svh-tickets-lib/tickets/public/operators';
import { Fragment } from 'react';
import { getIsClosed, getIsFiltered, getIsOpen, getIsSoftDeleted } from 'conversations-thread-data/thread-details/public/operators';
import { InlineLabel } from 'foundations-components/transitional/components/InlineLabel';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import TicketStatusLabel from 'conversations-thread-view/thread-toolbar/components/TicketStatusLabel';
import { ActionButton } from 'svh-workspace-ui-lib/detail-header/public/components';
import TicketStageDropdown from 'svh-workspace-ui-lib/ticket-header/public/TicketStageDropdown';
// @ts-expect-error type not available yet
import { ticketStageUpdated } from 'conversations-thread-view/thread-toolbar/actions/ticketStageUpdated';
import TicketOutOfSyncTooltip from './TicketOutOfSyncTooltip';
import { useTicketPipelines } from 'svh-tickets-lib/tickets/public/hooks';
import { useUpdateTicketProperties } from 'conversations-inbox-lib/tickets/mutations/useUpdateTicketProperties';
import { trackEvent } from '../../usage-tracking/clients/usageTracker';
import { isUngatedToTicketStatusConditionalProperties } from '../../selectors/gateSelectors';
import { useSelector } from 'react-redux';
import { DeleteIcon } from 'foundations-assets';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TicketPrimaryActions = ({
  ticketStages,
  isThreadStatusChangeInProgress,
  threadDetails,
  ticket,
  disabled,
  openDeletePrompt,
  ticketExists
}) => {
  const {
    pipelines: ticketPipelines
  } = useTicketPipelines();
  const {
    updateTicketProperties
  } = useUpdateTicketProperties({
    ticketId: ticket && ticket.id
  });
  const ungatedToTicketStatusConditionalProperties = useSelector(isUngatedToTicketStatusConditionalProperties);
  const closeable = getIsOpen(threadDetails);
  const openConversationWithTicketIsOutOfSync = closeable && ticket && isTicketClosed(ticket) && !isThreadStatusChangeInProgress;
  const closedConversationWithTicketIsOutOfSync = !closeable && ticket && !isTicketClosed(ticket) && !isThreadStatusChangeInProgress;
  const ticketAndConversationIsInSync = !openConversationWithTicketIsOutOfSync && !closedConversationWithTicketIsOutOfSync;
  const ticketDataLoaded = ticket && getObjectId(ticket) && ticketPipelines && ticketStages;
  const ticketIsLoading = ticketExists && !ticketDataLoaded;
  const renderTicketStageDropdown = () => {
    return /*#__PURE__*/_jsx(TicketStageDropdown, {
      ticket: ticket,
      ticketPipelines: ticketPipelines,
      ticketStages: ticketStages,
      updateTicketProperties: updateTicketProperties,
      ticketStageUpdated: ticketStageUpdated,
      trackEvent: trackEvent,
      ungatedToTicketStatusConditionalProperties: ungatedToTicketStatusConditionalProperties
    });
  };
  if (ticket && ticket.userPermissions && !ticket.userPermissions.currentUserCanView) {
    return null;
  }
  if (ticketIsLoading) {
    return /*#__PURE__*/_jsx(InlineLabel, {
      label: /*#__PURE__*/_jsx(TicketStatusLabel, {}),
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        size: "small"
      })
    });
  }
  if (ticket) {
    if (ticketDataLoaded && !getIsSoftDeleted(threadDetails) && ticketAndConversationIsInSync) {
      return renderTicketStageDropdown();
    }
    if (getIsClosed(threadDetails)) {
      return /*#__PURE__*/_jsx(Fragment, {
        children: /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx(TicketOutOfSyncTooltip, {
            isOpenConversation: false
          }), renderTicketStageDropdown()]
        })
      });
    } else if (closeable) {
      return /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx(TicketOutOfSyncTooltip, {
            isOpenConversation: true
          }), renderTicketStageDropdown()]
        }), getIsFiltered(threadDetails) && /*#__PURE__*/_jsx(ActionButton, {
          onClick: openDeletePrompt,
          disabled: disabled,
          icon: DeleteIcon,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ConversationsInboxUI.thread-deletion.deleteBtn"
          })
        })]
      });
    }
  }
  return null;
};
TicketPrimaryActions.displayName = 'TicketPrimaryActions';
export default TicketPrimaryActions;